import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { findParentPathById } from './findParentPathById';

export const makeBlockTitle = (tree: IPublishRulesTreeItem[], activeTreeItem: IPublishRulesTreeItem) => {
  const parents = findParentPathById(tree, activeTreeItem.id);

  if (Array.isArray(parents) && parents.length > 0) {
    const titles = [...parents, activeTreeItem].slice(1)?.map(item => item.title);

    if (titles.length > 0) {
      return titles.join(' / ');
    }
  }

  return activeTreeItem.title;
};
